import { IonCol, IonRow, IonText } from "@ionic/react";
import { formatUSDCurrency } from "../../../../utilities/currency/Currency";
import EntryCardChip from "../../../Chips/EntryCardChip";

/** Subsection footer: subtotal label + formatted currency (no edit). */
const SummarySubtotalRow: React.FC<{
    amountUsd: number;
    label?: string;
    showTopBorder?: boolean;
    removeTopSpacing?: boolean;
    bold?: boolean;
    lightText?: boolean;
    fontSize?: number;
    textTone?: "primary" | "dark";
    fontWeight?: number;
    isLoading?: boolean;
    /** When false, the Loading chip still shows but this row does not blink (parent already animates). */
    animateLoading?: boolean;
}> = ({
    amountUsd,
    label = "Subtotal",
    showTopBorder = true,
    removeTopSpacing = false,
    bold = false,
    lightText = false,
    fontSize = 16,
    textTone = "primary",
    fontWeight,
    isLoading = false,
    animateLoading = true,
}) => {
    const textClass = `${lightText ? "text-white" : textTone === "dark" ? "text-dark" : "text-primary"}${bold && fontWeight === undefined ? " font-weight-bold" : ""}`;
    const dynamicTextStyle: React.CSSProperties = {
        fontSize,
        ...(fontWeight !== undefined ? { fontWeight } : {}),
    };
    return (
        <IonRow
            className={`ion-align-items-center ion-justify-content-between mx-0 px-1 ${removeTopSpacing ? "pt-0 mt-0" : "pt-2 mt-1"}${
                showTopBorder ? " summary-subtotal-row--bordered" : ""
            }${isLoading && animateLoading ? " saving-blink-animation" : ""}`}
            aria-busy={isLoading || undefined}>
            <IonCol className="ion-no-padding">
                <IonText className={textClass} style={dynamicTextStyle}>
                    {label}
                </IonText>
            </IonCol>
            <IonCol size="auto" className="ion-no-padding ion-text-end d-flex ion-align-items-center ion-justify-content-end">
                {isLoading ? (
                    <EntryCardChip chipTitle="Loading" />
                ) : (
                    <IonText className={`${textClass} summary-subtotal-row__amount`} style={dynamicTextStyle}>
                        {formatUSDCurrency(amountUsd)}
                    </IonText>
                )}
            </IonCol>
        </IonRow>
    );
};

export default SummarySubtotalRow;
